import React from 'react'
import classnames from 'classnames'
import './GridSlants.scss'

function GridSlants({ children, className, cells = 0, skip = 0, ...props }) {
  // The position: relative fixes an overflow issue on mobile
  return (
    <div style={{ position: 'relative' }}>
      <div {...props} className={classnames('grid-slants', `skip-row-${skip}`, className)}>
        {Array.from(Array(cells).keys()).map((_, index) => {
          return <div key={index} className={`grid-slants-cell-${index + 1}`} />
        })}
        {children}
      </div>
    </div>
  )
}

export default GridSlants
